"use client";

import { useEffect } from "react";

type NotFoundMetadataProps = {
  title?: string;
  description?: string;
};

export function NotFoundMetadata({ title, description }: NotFoundMetadataProps) {
  useEffect(() => {
    if (title && document.title !== title) {
      document.title = title;
    }

    if (description) {
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        if (metaDescription.getAttribute("content") !== description) {
          metaDescription.setAttribute("content", description);
        }
      } else {
        const meta = document.createElement("meta");
        meta.name = "description";
        meta.content = description;
        document.head.appendChild(meta);
      }
    }
  }, [title, description]);

  return null;
}
